if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
    }

    connectedCallback() {
      this.mode = this.dataset.mode || 'evergreen';
      this.durationMs = (parseFloat(this.dataset.durationHours) || 2) * 60 * 60 * 1000;
      this.cookieName = this.dataset.cookieName || 'countdown_end';
      this.expiredMessage = this.dataset.expiredMessage || '';
      this.timezone = this.dataset.timezone || 'Australia/Sydney';

      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      this.initTimer();
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    initTimer() {
      if (this.mode === 'end-of-day') {
        this.endTime = this.getMidnightInTimezone(this.timezone);
      } else {
        let endTime = this.getCookie(this.cookieName);

        if (!endTime || parseInt(endTime) <= Date.now()) {
          endTime = Date.now() + this.durationMs;
          this.setCookie(this.cookieName, endTime, this.durationMs);
        }

        this.endTime = parseInt(endTime);
      }

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    getMidnightInTimezone(tz) {
      // Get current hours, minutes, seconds in the target timezone
      const now = new Date();
      const tzStr = now.toLocaleString('en-US', { timeZone: tz, hour12: false });
      const tzDate = new Date(tzStr);

      const h = tzDate.getHours();
      const m = tzDate.getMinutes();
      const s = tzDate.getSeconds();

      // Remaining milliseconds until midnight in that timezone
      const remainingMs = ((23 - h) * 3600 + (59 - m) * 60 + (60 - s)) * 1000;

      return Date.now() + remainingMs;
    }

    tick() {
      let remaining;

      if (this.mode === 'end-of-day') {
        // Recalculate to handle day changes
        remaining = this.getMidnightInTimezone(this.timezone) - Date.now();
        // After midnight, recalculate for the new day's end
        if (remaining <= 0 || remaining > 24 * 60 * 60 * 1000) {
          remaining = this.getMidnightInTimezone(this.timezone) - Date.now();
        }
      } else {
        remaining = this.endTime - Date.now();
      }

      if (remaining <= 0) {
        if (this.mode === 'end-of-day') {
          // Reset for new day
          remaining = this.getMidnightInTimezone(this.timezone) - Date.now();
          if (remaining <= 0) {
            // Edge case: show 00:00:00 briefly
            this.updateDisplay(0, 0, 0, 0);
            return;
          }
        } else {
          clearInterval(this.interval);
          if (this.expiredMessage) {
            this.innerHTML = `<span class="countdown-timer__expired">${this.expiredMessage}</span>`;
          } else {
            this.style.display = 'none';
          }
          this.deleteCookie(this.cookieName);
          return;
        }
      }

      const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      this.updateDisplay(days, hours, minutes, seconds);
    }

    updateDisplay(days, hours, minutes, seconds) {
      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }

    setCookie(name, value, durationMs) {
      const expires = new Date(Date.now() + durationMs).toUTCString();
      document.cookie = `${name}=${value};expires=${expires};path=/;SameSite=Lax`;
    }

    deleteCookie(name) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
